import { apiFetch } from './client';

export const usersApi = {
  list: (params) => apiFetch('/api/users', { params }),
  me: () => apiFetch('/api/users/me'),
  get: (id) => apiFetch(`/api/users/${id}`),
  create: (payload) => apiFetch('/api/users', { method: 'POST', body: payload }),
  update: (id, payload) =>
    apiFetch(`/api/users/${id}`, { method: 'PATCH', body: payload }),
};
